var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isAdmin, isLawyer, isUser, isMaster } from '../../helpers/Utils';
import { USER_INFO, USER_INFO_ERROR, USER_INFO_SUCCESS, SET_HOLDER, SET_ORGANIZATION, SET_ORGANIZATIONS, SET_USER, SET_USER_LOADING, SET_TOTAL_NOTIFICATIONS, SET_PLANS, } from '../actions';
/* eslint-disable import/no-anonymous-default-export */
var INIT_STATE = {
    user: {
        id: null,
        firstName: null,
        lastName: null,
        email: null,
        picture: null,
        token: null,
    },
    holder: null,
    organization: {
        amHolder: false,
        amAdmin: false,
        amUser: false,
        amLawyer: false,
        general: {
            totalNotifications: null,
        },
        settings: {
            notifications: {
                changeProcess: false,
                newProcess: false,
            },
        },
        roles: [],
        plans: [],
    },
    organizations: [],
    loading: true,
    error: '',
};
export default (function (state, action) {
    if (state === void 0) { state = INIT_STATE; }
    switch (action.type) {
        case USER_INFO:
            return __assign({}, state);
        case USER_INFO_SUCCESS:
            return __assign(__assign({}, state), { loading: false });
        case USER_INFO_ERROR:
            return __assign(__assign({}, state), { loading: false });
        case SET_USER:
            return __assign(__assign({}, state), { user: __assign(__assign({}, state.user), action.payload) });
        case SET_HOLDER:
            var holder = action.payload;
            return __assign(__assign({}, state), { holder: holder, organization: __assign(__assign({}, state.organization), { amHolder: !!holder }) });
        case SET_PLANS:
            return __assign(__assign({}, state), { organization: __assign(__assign({}, state.organization), { plans: action.payload }) });
        case SET_ORGANIZATION:
            var profile = action.payload.profile;
            var type = action.payload.type;
            return __assign(__assign({}, state), { organization: __assign(__assign(__assign({}, state.organization), action.payload), { amAdmin: isAdmin(profile), amUser: isUser(profile), amLawyer: isLawyer(profile), amMaster: isMaster(type) }) });
        case SET_ORGANIZATIONS:
            return __assign(__assign({}, state), { organizations: action.payload });
        case SET_TOTAL_NOTIFICATIONS:
            return __assign(__assign({}, state), { organization: __assign(__assign({}, state.organization), { general: __assign(__assign({}, state.organization.general), { totalNotifications: action.payload }) }) });
        case SET_USER_LOADING:
            return __assign(__assign({}, state), { loading: action.payload });
        default:
            return __assign({}, state);
    }
});
